'use client';
import { DEFAULT_LOCALE, isServer } from '../constants.js';

/**
 * Format rate to include zeros
 * @param rate integer value
 * @param minimumFractionDigits minimum number of digits to show after the decimal point [default: 2]
 * @param maximumFractionDigits maximum number of digits to show after the decimal point [default: minimumFractionDigits]
 * @returns formatted rate, like '5.00'
 */
const formatRate = (rate, minimumFractionDigits = 1, maximumFractionDigits = 2) => {
    let locale = DEFAULT_LOCALE;
    // TODO: Migrate to use the next locale (maybe this abstracts the server and client)
    if (!isServer && window?.navigator?.language != null) {
        locale = window.navigator.language;
    }
    const normalizedMinimumFractionDigits = Math.max(0, minimumFractionDigits);
    const normalizedMaximumFractionDigits = Math.max(normalizedMinimumFractionDigits, maximumFractionDigits);
    const numWithZeroes = rate.toLocaleString(locale, {
        useGrouping: false,
        minimumFractionDigits: normalizedMinimumFractionDigits,
        maximumFractionDigits: normalizedMaximumFractionDigits,
    });
    return numWithZeroes;
};

export { formatRate };
//# sourceMappingURL=format-rate.js.map
